<script>
	// Stores
	import { 
		linkMapa,
		linkWaze,
		linkUber,
		linkAV, 
		linkAPI, 
		tagsSEO, 
		textEndereco, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		todosContatos, 
		linkFacebook,
		linkInstagram,
		linkTwitter,
		linkYoutube,
		linkWhatsappVendas,
		linkWhatsappLocacao,
		linkPoliticaPrivacidade,
		linkPoliticaCookies
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fas fa-waze"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fas fa-uber"></i>',
			link: $linkUber,
		},
	];
</script>

<footer>
	<section class="footer-banner">
		<div class="container">
			<div class="flex sm-flex-column flex-center gap-10 pt-10 pb-10" style="width: 100%;">
				<p class="color-white">Fale com a gente</p>
				{#each $todosContatos as contato}
				<a target="_blank" href="{contato.href}"><span class="color-white">•</span> {@html contato.icon} {contato.phone}</a>
				{/each}
			</div>
		</div>
	</section>
	<section class="informacoes">
		<div class="container">
			<div class="content flex sm-flex-column sm-flex-center">
				<div class="seo">
					<img class="mb-20" src="/assets/images/logotipoFooter.png" alt="Sede da São Pedro Imóveis" />
					<p>{@html $tagsSEO}</p>
				</div>
				<div class="flex-1 localizacao">
					<h4><i class="fas fa-map-marker color-accent"></i> ATENDIMENTO</h4>
					<p>{@html $textAtendimento}</p>
				</div>
				<div class="sede">
					<h4><i class="fas fa-map-marker color-accent"></i> ENDEREÇO</h4>
					<p>{@html $textEndereco}</p>
					<div class="travel flex gap-10 pb-20">
						<a href={$linkMapa} target="_blank"><i class="fal fa-map-marked-alt"></i> Mapa</a>
						<a href={$linkWaze} target="_blank"><i class="fab fa-waze"></i> Waze</a>
						<a href={$linkUber} target="_blank"><i class="fab fa-uber"></i> Uber</a>
					</div>
					<a class="text-smaller" href={$linkPoliticaPrivacidade} target="_blank">Política de Privacidade</a>
				</div>
			</div>
			<div class="copyright">
				<copy>@ 2022 - São Pedro Imóveis - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os direitos reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a></copy>
			</div>
		</div>
	</section>
</footer>